import { GET, POST, PUT } from "./common/http";
import { BASE_URL } from "./common/const";
import axios from "axios";

export const CreateStake = (data: any) =>
  POST(`${BASE_URL}/stake/create`, data);

export const UpdateStake = (data: any) => PUT(`${BASE_URL}/stake/update`, data);

//  export const GetStakeDetail = (params: any) =>
//   GET(`${BASE_URL}/stake/detail?` + params, null);
export const GetStakeDetail = (params: any) =>
  axios.get(`${BASE_URL}/stake/detail`, { params });

export const GetStakeList = (params: any, options?: { signal?: AbortSignal }) =>
  GET(`${BASE_URL}/stake/list?` + params, { signal: options?.signal });

// export const DeleteStake = (data: any) => PUT(`${BASE_URL}/stake/delete`, data);
export const DeleteStake = (UID: number) =>
  axios.delete(`${BASE_URL}/stake/delete`, {
    params: { UID },
  });
//  export const UpdateParentStackId = (UID: number, PARENT_STAKE_ID: number) =>
//   PUT(`${BASE_URL}/stake/update`, {
//     UID,
//     PARENT_STAKE_ID,
//   });

export async function UpdateGraphList(UID: number, isGraph: boolean) {
  return axios.put(`${BASE_URL}/stake/update-graph`, {
    UID,
    isGraph,
  });
}
